(function(){
  function initMenu(){
    const menu=document.getElementById('pbMenu'),nav=document.getElementById('pbNav');
    if(!menu||!nav||menu.dataset.pbMenuReady==='true')return;
    menu.dataset.pbMenuReady='true';
    function close(){
      nav.classList.remove('is-open','pb-menu-highlight');
      document.body.classList.remove('pb-menu-open');
      menu.setAttribute('aria-expanded','false');
      menu.setAttribute('aria-label','Open menu');
    }
    menu.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      const open=nav.classList.toggle('is-open');
      document.body.classList.toggle('pb-menu-open',open);
      menu.setAttribute('aria-expanded',open?'true':'false');
      menu.setAttribute('aria-label',open?'Close menu':'Open menu');
      if(open) nav.classList.add('pb-menu-highlight');
      else nav.classList.remove('pb-menu-highlight');
    });
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
    document.addEventListener('click',function(e){
      if(nav.classList.contains('is-open')&&!nav.contains(e.target)&&!menu.contains(e.target))close();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    window.addEventListener('resize',function(){if(window.innerWidth>800) nav.classList.remove('is-open');});
  }
  function initQty(){
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn){
      if(btn.dataset.pbQtyReady==='true')return;btn.dataset.pbQtyReady='true';
      btn.addEventListener('click',function(){const input=btn.parentElement.querySelector('.pb-qty-input');if(!input)return;input.value=Math.max(1,(parseInt(input.value,10)||1)-1);input.dispatchEvent(new Event('change',{bubbles:true}));});
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn){
      if(btn.dataset.pbQtyReady==='true')return;btn.dataset.pbQtyReady='true';
      btn.addEventListener('click',function(){const input=btn.parentElement.querySelector('.pb-qty-input');if(!input)return;input.value=(parseInt(input.value,10)||1)+1;input.dispatchEvent(new Event('change',{bubbles:true}));});
    });
  }
  function initSliders(){
    document.querySelectorAll('.pb-slider-arrow').forEach(function(btn){
      if(btn.dataset.pbSliderReady==='true')return;btn.dataset.pbSliderReady='true';
      btn.addEventListener('click',function(){
        const dots=document.querySelectorAll('.pb-slider-dots span');
        if(!dots.length)return;
        let current=[...dots].findIndex(d=>d.classList.contains('is-active'));if(current<0)current=0;
        const next=btn.classList.contains('pb-slider-next')?(current+1)%dots.length:(current-1+dots.length)%dots.length;
        dots.forEach(d=>d.classList.remove('is-active'));dots[next].classList.add('is-active');
      });
    });
  }
  function init(){initMenu();initQty();initSliders();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
